/**
 * Which companions of one main guest a surface is asking for.
 *
 * Mirrors `org.nikita.enums.CompanionScope` in main-backend, which owns the
 * predicates. The values are sent verbatim as `?scope=` — keep the spelling.
 *
 * Why this exists: every surface that shows a party used to answer the question
 * for itself and they answered differently. The guest list and every count mean
 * {@link COMPANION_SCOPE.PARTY}; the guest popup asked the widest question there
 * was and got back the very rows an organiser had just "deleted" (a delete there
 * is stored as `acceptanceState: DECLINED`), while the guest list never showed
 * them. Naming the set is what stops the two from drifting apart again.
 *
 * Omitting the scope means "the set this route has always answered" — anything
 * but DECLINED, archived rows included. Two callers deliberately keep it
 * (`party.ts`, `AttachmentPreview.tsx`); see their own comments for why.
 */
export const COMPANION_SCOPE = {
  /** Not archived, and either accepted/system or parked on the waitlist. */
  PARTY: "PARTY",
  /** The party plus the still-undecided requests (PENDING, not archived). */
  PARTY_AND_REQUESTS: "PARTY_AND_REQUESTS",
  /** Every row pointing at the host — declined and archived included. */
  ALL: "ALL",
} as const;

export type CompanionScope =
  (typeof COMPANION_SCOPE)[keyof typeof COMPANION_SCOPE];
